module.exports = __webpack_public_path__ + "static/media/external.a93dbacd.svg";